import favoritesStore from '../store/store';
import { mutatorAction } from 'satcheljs';

export const setCombinedFavoriteIdsInStore = mutatorAction(
    'setCombinedFavoriteIdsInStore',
    (favoriteIds: string[]) => {
        favoritesStore.orderedCombinedOutlookFavoritesIds = favoriteIds;
    }
);
